import React from 'react'
import { M_TextArea } from 'src/components/M_Components'

export default function Observations({ optionsOrderService, addOrderService, orderService, t }) {

    return (
        <div className='divCardSmall'>
            <div className='divTitleCard'>
                <div className='divSizeTitle'>
                    <div className='iconTitleCard'>
                        <img src="/icons/svgsDaNet/info-circle.svg"
                            style={{ filter: 'invert(16%) sepia(66%) saturate(5073%) hue-rotate(347deg) brightness(74%) contrast(116%)' }}
                            alt="Observations"
                        />
                    </div>
                    <div className='labelTitleCard'>
                        {t("Observations")}
                    </div>
                </div>
            </div>
            <div className='marginTopInputReceiver'>
                {optionsOrderService.filter((elem) => elem.GroupByInfo === 'Notes').map((elem6, key6) => (
                    <div key={key6}>
                        <M_TextArea
                            label={elem6.NormalizedName}
                            required={elem6.IsRequired}
                            onChange={(e) => addOrderService(e.target.value, elem6.Name)}
                            value={orderService.get(elem6.Name) || ""}
                        />
                    </div>
                ))}
            </div>
        </div>
    )
}